<template>
  <div :class="navColorClass.bg">
    <b-navbar toggleable="lg" class="top p-0 position-relative mr-0 mr-lg-3">
      <b-navbar-brand class="p-3">
        <router-link to="/" aria-label="Home">
          <b-img
            v-if="navColorClass.color === 'bright-yellow'"
            style="width: 42px; margin-top: -10px; border: none"
            src="https://res.cloudinary.com/oredev/image/upload/v1742460344/2025/%C3%98_logo_yellow.svg"
            alt=""
          />
          <b-img
            v-else
            style="width: 42px; margin-top: -10px; border: none"
            src="https://res.cloudinary.com/oredev/image/upload/v1712152990/2024/logo12.png"
            alt=""
          />
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" class="p-3">
        <span
          class="material-symbols-outlined"
          style="font-size: 2rem !important"
          :class="navColorClass.color"
        >
          menu
        </span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="text-center mb-3 mb-lg-0">
        <p class="d-lg-none info-text">
          Wondering when?<br aria-hidden="true" />
          5-7 Nov 2025 - Malmö, Sweden
        </p>
        <b-navbar-nav class="ml-auto" :class="navColorClass.color">
          <b-nav-item to="/tickets" active-class="beige-active-link"
            >Tickets</b-nav-item
          >
          <b-nav-item
            hidden
            :to="{
              path: '/line-up',
              query: { tags: $route.query.tags },
            }"
            >Line-up</b-nav-item
          >
          <b-nav-item hidden to="/program">Program</b-nav-item>
          <b-nav-item hidden to="/oredev-plus">Øredev+</b-nav-item>
          <b-nav-item to="/info" active-class="beige-active-link"
            >Info</b-nav-item
          >
          <b-nav-item hidden @click="navigateToMySchedule"
            ><div
              style="display: inline-block"
              :class="[{ 'schedule-active': isMyScheduleActive }]"
            >
              My Schedule
            </div>
            <div class="calendar-icon ml-1" aria-hidden="true">
              <i
                class="material-icons schedule-icon"
                :class="navColorClass.color"
                >calendar_today</i
              >
              <span class="my-count badge-circle">{{
                $store.state.count
              }}</span>
            </div>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "top",
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  data() {
    return {
      scrollPosition: "0",
      active: false,
      windowWidth: window.innerWidth,
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
      if (window.scrollY > 200) {
        this.active = true;
      } else {
        this.active = false;
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    navigateToMySchedule() {
      const id =
        this.$route.params.id ||
        localStorage.getItem("myscheduleid") ||
        localStorage.getItem("revertmyschedule");
      // If one is viewing other's schedule, add nochange query
      const query = localStorage.getItem("revertmyschedule")
        ? { nochange: true }
        : {};
      if (id) {
        // Navigate to MySchedule with ID
        this.$router.push({
          name: "MySchedule",
          params: { id: id },
          query: query,
        });
      } else {
        // Navigate to MySchedule without ID
        this.$router.push({ name: "MySchedule" });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  computed: {
    navColorClass() {
      const groupA = ["/", "/tickets", "/info"];
      if (groupA.includes(this.$route.path)) {
        return {
          bg: "bg-dark-brown",
          color: "bright-yellow",
          infoColor: "bright-yellow",
        };
      }
      return {
        bg: "",
        color: "dark-brown",
        infoColor: "light-pink",
      };
    },
    isMyScheduleActive() {
      return this.$route.name === "MySchedule";
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

.top {
  z-index: 99;
}

.info-text {
  color: $light-pink;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: uppercase;
}

.material-icons {
  font-size: 35px;
}

.calendar-icon {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
}
.schedule-icon {
  font-size: 24px;
  line-height: 0px;
  position: absolute;
  top: 13px;
  right: 0px;
}

.badge-circle {
  width: 18px;
  height: 17px;
  position: absolute;
  top: 0px;
  right: 9px;

  font-family: Lexend, sans-serif;
  font-size: 12px;
  line-height: 0px;
  letter-spacing: 0;

  background-color: $light-pink;
  color: $white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-toggler {
  border: none;
}
a.nav-link {
  text-transform: uppercase;
  font-weight: 400;
  text-decoration: none !important;
  font-size: 18px;
  letter-spacing: 2px;
  text-align: center;
  color: inherit !important;
}

.navbar-nav a.router-link-exact-active,
.schedule-active {
  color: $dark-brown !important;
  // Custom underline:
  position: relative;
  display: inline-block;
  // Replace padding with margin for custom underliine
  padding: 0 !important;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px; /* 👈 controls how far below the text it is */
    height: 2.5px; /* 👈 thickness of underline */
    background-color: currentColor; /* or custom color */
  }
}

.navbar-nav a.router-link-exact-active {
  margin: 0.5rem;
}

.navbar-nav a.router-link-exact-active.beige-active-link {
  color: $beige !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue